'use strict';

exports.array = require('./array');
exports.matrix = require('./matrix');



// WEBPACK FOOTER //
// ./packages/emdb/node_modules/ml-stat/index.js